import { render, staticRenderFns } from "./daily-cargo-edit-identity-check-sheet.vue?vue&type=template&id=737d64a1"
import script from "./daily-cargo-edit-identity-check-sheet.vue?vue&type=script&lang=js"
export * from "./daily-cargo-edit-identity-check-sheet.vue?vue&type=script&lang=js"
import style0 from "./daily-cargo-edit-identity-check-sheet.vue?vue&type=style&index=0&id=737d64a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports